import { ApartmentCountLimitsPort } from '../application/ports/ApartmentCountLimitsPort';

export class ApartmentCountLimits implements ApartmentCountLimitsPort {
  getMin(): number {
    return 2;
  }

  getMax(): number {
    return 20;
  }
}
